import '@tarojs/plugin-platform-h5/dist/runtime'

import { initPxTransform } from '@tarojs/taro'
import { createRouter, createBrowserHistory, handleAppMount } from '@tarojs/router'
import component from "./app"
import { window } from '@tarojs/runtime'
import { createReactApp } from '@tarojs/plugin-framework-react/dist/runtime'

import * as React from 'react'
import ReactDOM from 'react-dom/client'

import { findDOMNode, render, unstable_batchedUpdates } from 'react-dom'
import { defineCustomElementTaroPullToRefreshCore } from '@tarojs/components/dist/components'


var config = {"router":{"mode":"browser"},"pages":["pages/user/index","pages/business/index","pages/register/index","pages/settle/index","pages/about/index","pages/certificate/index","pages/webview/index","pages/realname-confirm/index","pages/realname/index","pages/sign/index","pages/sign-result/index","pages/task-detail/index","pages/salary/index","pages/banks/index","pages/login/index","pages/logout/index","pages/mask/index","pages/contract/index","pages/employer/index","pages/employer-contract/index","pages/account-safe/index","pages/log-off/index","pages/tip-account-invalid/index","pages/task-hall/index","pages/task-mine/index","pages/task-finish/index","pages/task-record/index","pages/insure/index"],"window":{"backgroundTextStyle":"light","navigationBarBackgroundColor":"#fff","navigationBarTitleText":"京灵","navigationBarTextStyle":"black"}}
window.__taroAppConfig = config

if (config.tabBar) {
  var tabbarList = config.tabBar.list
  for (var i = 0; i < tabbarList.length; i++) {
    var t = tabbarList[i]
    if (t.iconPath) {
      t.iconPath = tabbarIconPath[i]
    }
    if (t.selectedIconPath) {
      t.selectedIconPath = tabbarSelectedIconPath[i]
    }
  }
}
config.routes = [
  Object.assign({
  path: 'pages/user/index',
  load: function(context, params) {
    const page = import("./pages/user/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"个人中心"}),Object.assign({
  path: 'pages/business/index',
  load: function(context, params) {
    const page = import("./pages/business/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"京灵平台"}),Object.assign({
  path: 'pages/register/index',
  load: function(context, params) {
    const page = import("./pages/register/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"开通账号"}),Object.assign({
  path: 'pages/settle/index',
  load: function(context, params) {
    const page = import("./pages/settle/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"注册指引"}),Object.assign({
  path: 'pages/about/index',
  load: function(context, params) {
    const page = import("./pages/about/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"用户协议"}),Object.assign({
  path: 'pages/certificate/index',
  load: function(context, params) {
    const page = import("./pages/certificate/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"我的证件"}),Object.assign({
  path: 'pages/webview/index',
  load: function(context, params) {
    const page = import("./pages/webview/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/realname-confirm/index',
  load: function(context, params) {
    const page = import("./pages/realname-confirm/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"开通账号"}),Object.assign({
  path: 'pages/realname/index',
  load: function(context, params) {
    const page = import("./pages/realname/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"实名认证"}),Object.assign({
  path: 'pages/sign/index',
  load: function(context, params) {
    const page = import("./pages/sign/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/sign-result/index',
  load: function(context, params) {
    const page = import("./pages/sign-result/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/task-detail/index',
  load: function(context, params) {
    const page = import("./pages/task-detail/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"任务详情"}),Object.assign({
  path: 'pages/salary/index',
  load: function(context, params) {
    const page = import("./pages/salary/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"我的佣金"}),Object.assign({
  path: 'pages/banks/index',
  load: function(context, params) {
    const page = import("./pages/banks/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/login/index',
  load: function(context, params) {
    const page = import("./pages/login/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"登录"}),Object.assign({
  path: 'pages/logout/index',
  load: function(context, params) {
    const page = import("./pages/logout/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"退出登录"}),Object.assign({
  path: 'pages/mask/index',
  load: function(context, params) {
    const page = import("./pages/mask/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"提示"}),Object.assign({
  path: 'pages/contract/index',
  load: function(context, params) {
    const page = import("./pages/contract/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"我的合同"}),Object.assign({
  path: 'pages/employer/index',
  load: function(context, params) {
    const page = import("./pages/employer/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/employer-contract/index',
  load: function(context, params) {
    const page = import("./pages/employer-contract/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/account-safe/index',
  load: function(context, params) {
    const page = import("./pages/account-safe/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"账户与安全"}),Object.assign({
  path: 'pages/log-off/index',
  load: function(context, params) {
    const page = import("./pages/log-off/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"账户与安全"}),Object.assign({
  path: 'pages/tip-account-invalid/index',
  load: function(context, params) {
    const page = import("./pages/tip-account-invalid/index")
    return [page, context, params]
  }
}, {}),Object.assign({
  path: 'pages/task-hall/index',
  load: function(context, params) {
    const page = import("./pages/task-hall/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"任务大厅"}),Object.assign({
  path: 'pages/task-mine/index',
  load: function(context, params) {
    const page = import("./pages/task-mine/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"任务大厅"}),Object.assign({
  path: 'pages/task-finish/index',
  load: function(context, params) {
    const page = import("./pages/task-finish/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"完成任务"}),Object.assign({
  path: 'pages/task-record/index',
  load: function(context, params) {
    const page = import("./pages/task-record/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"交付记录"}),Object.assign({
  path: 'pages/insure/index',
  load: function(context, params) {
    const page = import("./pages/insure/index")
    return [page, context, params]
  }
}, {"navigationBarTitleText":"商业保险服务"})
]
Object.assign(ReactDOM, { findDOMNode, render, unstable_batchedUpdates })
defineCustomElementTaroPullToRefreshCore()

var inst = createReactApp(component, React, ReactDOM, config)
var history = createBrowserHistory({ window })
handleAppMount(config, history)
createRouter(history, inst, config, React)
initPxTransform({
  designWidth: 750,
  deviceRatio: {"640":1.17,"750":1,"828":0.905},
  baseFontSize: 20,
  unitPrecision: undefined,
  targetUnit: undefined
})
